export default {
  install (Vue, options) {
    Vue.prototype.$getChanges = function (params, type, module, dataClass, oldForm) {
      let changedata = {}
      for (let key in oldForm) {
        if (oldForm[key] !== params[key]) {
          changedata[key] = params[key]
        }
      }
      // let module = 'security'
      let obj = {
        'id': params.id,
        'type': type,
        'data': changedata
      }
      // let data_class = 'SafetyEngineer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/getChages.js